// authorization
export const OAUTH_AUTHORIZE = 'OAUTH_AUTHORIZE';
export const OAUTH_AUTHORIZE_REQUEST = 'OAUTH_AUTHORIZE_REQUEST';
export const OAUTH_AUTHORIZE_SUCCESS = 'OAUTH_AUTHORIZE_SUCCESS';
export const OAUTH_AUTHORIZE_FAILURE = 'OAUTH_AUTHORIZE_FAILURE';
